<template>
  <div :id="id" class="section__layout d-flex flex-column mb-2 bg-white p-2">
    <div class="section__layout-heading d-flex align-items-center justify-content-between mb-2 pb-2">
      <span class="section__layout-title text-light-high heading-16-medium">
        {{ title }}
      </span>
      <div class="section__layout-sub-title text-light-disabled body-12-regular">
        {{ subTitle }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionLayout',
  props: {
    id: String,
    title: String,
    subTitle: String,
  },
};
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.section__layout {
  border-radius: 3px;
  &-heading {
    border-bottom: solid 1px $text-dark-high;
  }
}
</style>
